import React from 'react';
import ReactDOM from 'react-dom';
import {Provider} from 'react-redux';

import App from './App';
import httpClient, {attachInterceptors} from './httpClient';
import {login, setConfig} from './state/actions';
import configureStore, {history} from './state/store';

import 'semantic-ui-css/semantic.min.css';

const store = configureStore();
attachInterceptors(store);

const token = localStorage.getItem('token');
const user = localStorage.getItem('user');

if (token && user) {
  store.dispatch(login(token, JSON.parse(user)));
}

httpClient.get('/api/config').then(({data}) => {
  store.dispatch(setConfig(data));
});

ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <App history={history} />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);
